import CreateAccess from './CreateAccess'
import SetupPassword from './SetupPassword'
import SignUp from './SignUp'

const CreateAccessStep = {
  SetupPassword,
  SignUp,
}

export { CreateAccessStep }
export default CreateAccess
